const externalParameterStatus = {
    NOT_SET: null,
    ACTIVE: 1,
    INACTIVE: 0,
};
export { externalParameterStatus };
